export default (el) => {

  const $body = $('body'),
        $siteHeader = $('.site-header');

  // Toggles transparent class to site header on front page on scroll
  $(window).scroll(function() {
    if ($body.hasClass('front-page')) {
      if ($(this).scrollTop() > 100) {
        $siteHeader.removeClass('transparent');
      } else {
        $siteHeader.addClass('transparent');
      }
    }
  });
}